import theme from "../styles/Theme";

import { StyleProject, StyleProjectTitle, StyleContentsArea, StyleContentsLeft, StyleContentsRight, StyleContentsTitle, StyleContents, StyleContent } from "../styles/StyleProjects"

import { StyleBadgeGreen } from '../styles/StyleCommon'

const AiProductivity = () => {
    return (
        <div>
            <StyleProject>
                <StyleContentsArea theme={theme}>
                    <StyleContentsLeft>
                        <blockquote>
                            <StyleProjectTitle>2026.01 - 2026.03</StyleProjectTitle>
                            <StyleProjectTitle>AI 기반 개발 생산성 자동화</StyleProjectTitle>
                            <StyleBadgeGreen>n8n</StyleBadgeGreen>
                            <StyleBadgeGreen>claude ai</StyleBadgeGreen>
                            <StyleBadgeGreen>datadog api</StyleBadgeGreen>
                            <StyleBadgeGreen>atlassian api</StyleBadgeGreen>
                            <StyleBadgeGreen>slack api</StyleBadgeGreen>
                        </blockquote>
                    </StyleContentsLeft>
                    <StyleContentsRight>
                        <StyleContentsTitle>개발 워크플로우의 AI 자동화</StyleContentsTitle>
                        <StyleContents>
                            <StyleContent>AI 코드리뷰 에이전트를 통해 소스코드, 설계문서, DB 스키마를 교차 검증하는 컨텍스트 인지 리뷰 자동화</StyleContent>
                            <StyleContent>AI QA 에이전트를 통해 배포 후 코드와 요구사항 기반으로 API를 직접 호출하며 자율적으로 테스트를 수행하고 결과를 자동 기록</StyleContent>
                            <StyleContent>AI DBA 에이전트를 통해 코드 변경 내 Entity 변경을 자동 감지하고, 테이블 구조와 인덱스를 분석하여 성능 리스크를 사전에 탐지</StyleContent>
                        </StyleContents>
                        <StyleContentsTitle>AI 장애 리포트와 분석</StyleContentsTitle>
                        <StyleContents>
                            <StyleContent>에러 탐지부터 코드 레벨 원인 분석까지 수분에서 수시간 걸리던 과정을 1분 이내로 단축하는 에러 분석기 개발</StyleContent>
                            <StyleContent>업무에 자연스럽게 스며든 에러 자동 리포트와 필요 시 상세 분석을 요청할 수 있는 수동 리포트 체계 구축</StyleContent>
                            <StyleContent>데이터 수집과 코드 분석을 각각 전담하는 2개의 AI 에이전트를 분리하여 역할별 최적화된 분석 수행</StyleContent>
                        </StyleContents>
                        <StyleContentsTitle>팀 전체의 생산성 향상</StyleContentsTitle>
                        <StyleContents>
                            <StyleContent>코드리뷰 자동화로 PR 피드백 대기시간을 제거하고 일관된 리뷰 품질 확보</StyleContent>
                            <StyleContent>에러 분석 자동화로 장애 인지부터 원인 파악까지 걸리는 시간을 획기적으로 단축</StyleContent>
                            <StyleContent>개발자가 반복적인 검증과 분석 업무 대신 핵심 개발에 집중할 수 있는 AI-Driven 개발 환경 구축</StyleContent>
                        </StyleContents>
                    </StyleContentsRight>
                </StyleContentsArea>
            </StyleProject>
        </div>
    )
}

export default AiProductivity
